// Import Core
import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
// Import Components
import CardCarousel from '../CardCarousel';
// Import Utils
import getNavItemLinks from '../../../utils/getNavItemLinks';

const AutoAttractionsCardCarousel = ({ section }) => {
	const data = useStaticQuery(graphql`
		query AttractionsQuery {
			attractions: allSanityAttraction(limit: 10, sort: { _createdAt: DESC }) {
				nodes {
					_id
					_type
					title
          # FOLLOW UP:  DO I NEED THIS INSTEAD OF LIMITING TO 10?
					# location {
					# 	alt
					# 	lat
					# 	lng
					# }
					image: thumbnail {
						asset {
							gatsbyImageData(height: 280)
						}
					}
					content: excerpt
					city {
						name
					}
					country {
						_id
						_type
						name
						isInEurope
						slug {
							current
						}
					}
          slug {
            current
          }
				}
			}
		}
	`);
  const attractions = data.attractions.nodes;
	
  // Map over attractions and add a new key/value pair "subheading" & "tagline"
  attractions.map(attraction => {
    attraction.subheading = `${attraction.city.name}, ${attraction.country.name}`
    attraction.tagline = "Attractions"
    return attraction;
  })

	return (
		<CardCarousel
      addToAnchor={section.addToAnchor}
      subtitle={section.sectionTitle?.subheading}
      title={section.sectionTitle?.title}
      content={section.sectionTitle?.caption}
      linkText={section.navItem && section.navItem.name}
      link={(section.navItem && section.navItem.navItemUrl) && getNavItemLinks(section.navItem)}
			cardList={data.attractions.nodes}
		/>
	);
};

export default AutoAttractionsCardCarousel;
